const __WEBPACK_NAMESPACE_OBJECT__ = require("live/components/widget/ui/y-axis-config/y-axis-config-modal");